import { render, staticRenderFns } from "./NavPage.vue?vue&type=template&id=a6bb512a&scoped=true&"
import script from "./NavPage.vue?vue&type=script&lang=js&"
export * from "./NavPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bb512a",
  null
  
)

export default component.exports